import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
/** Reducers Import */
import { BookmarkActions } from "../../services/Redux/BookmarkReducer";
/** Services Impaort */
import Global from "../../services/Common/Global";
import Commons from "../../services/Common/Common";
import IndexedDb from "../../services/IndexedDb/IndexedDb";
/** Components Import */
import { Loading, Button, Dropdown, Dialog, Radio } from "../../Components/Bootstrap";
import { Stack, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
/** Icons Import */
import { faStar, faRotateRight } from "@fortawesome/free-solid-svg-icons";

function AccidentCar() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [reloadTime, setReloadTime] = useState(Commons.Storages("get", "saves").reloadTime);
  const bookmarkStates = useSelector((state) => state.Bookmarks);
  const [userInfo, setUserInfo] = useState("");
  const [selectedBusTitle, setSelectedBusTitle] = useState("버스를 선택하세요.");
  const [selectBusValue, setSelectBusValue] = useState(""); // 선택한 노선
  const [routes, setRoutes] = useState([]); // 노선 데이터 조회
  const [carList, setCarList] = useState([]); // 버스 배차 조회
  const [dialogToggle, setDialogToggle] = useState(false);
  const [carList1, setCarList1] = useState([]); // 운행 중 배차 시간표 조회 리스트
  const [selectedCardIndex, setSelectedCardIndex] = useState(null); // 운행 중 배차 목록에서 클릭한 항목
  const [accidentRadioValue, setAccidentRadioValue] = useState(""); // 사고/고장 라디오 버튼 값
  const [stationList, setStationList] = useState([]); // 정류장 목록
  const [selectStationValue, setSelectStationValue] = useState(""); // 정류장 선택 항목
  const [dialogToggle1, setDialogToggle1] = useState(false); // 대차 처리 팝업
  const [changeCarRadioValue, setChangeCarRadioValue] = useState("Y"); // 대차처리 예/아니오 데이터
  const [changeCarList, setChangeCarList] = useState([]); // 대차 콤보 리스트
  const [changeCarValue, setChangeCarValue] = useState(""); // 대차 콤보 선택 항목
  const [holidayPeopleList, setHolidayPeopleList] = useState([]); // 휴무자 콤보 리스트
  const [holidayPeopleValue, setHolidayPeopleValue] = useState(""); // 휴무자 콤보 선택 항목
  const [workPeopleList, setWorkPeopleList] = useState([]); // 근무자 콤보 리스트
  const [workPeopleValue, setWorkPeopleValue] = useState(""); // 근무자 콤보 선택 항목
  const [rideRadioValue, setRideRadioValue] = useState(""); // 적용 회차 선택 항목
  const [dialogToggle2, setDialogToggle2] = useState(false); // 승인 확인 팝업
  const [selectedItem, setSelectedItem] = useState({}); // 승인할 리스트 항목 저장

  useEffect(() => {
    Init();
  }, []);

  useEffect(() => {
    const Interval = setInterval(() => {
      if (reloadTime == "00") {
        return;
      }
      if (selectBusValue) {
        SelectLogic1(selectBusValue);
      }
    }, Number(reloadTime) * 1000);
    return () => clearInterval(Interval);
  }, [selectBusValue]);

  const Init = async () => {
    try {
      await IndexedDb.GetLoginInfo().then((result) => setUserInfo(result));
      await SelectLogic(); // 노선 데이터 조회
      if (bookmarkStates.bookmarks) {
        setSelectedBusTitle(bookmarkStates.busNo);
        setSelectBusValue(bookmarkStates.routeId);
        SelectLogic1(bookmarkStates.routeId);
      } else {
        setSelectedBusTitle("버스를 선택해주세요.");
      }
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    }
  };

  // 노선 데이터 조회
  const SelectLogic = async () => {
    setLoading(true);
    let _routes = [];

    try {
      await Commons.Axios("get", Global.base.useUrl + Global.urls.Common.GetCode, {
        code: "route",
        key1: "",
        key2: "",
        key3: "",
        key4: "",
      }).then((result) => {
        let data = result.data;
        // console.log("노선 데이터 조회: ", data);

        if (data.type == "Error") {
          throw new Error(data.message);
        } else if (data === "데이터가 없습니다.") {
          // throw new Error(data);
        } else if (data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            _routes.push(data[i]);
          }
          setRoutes(_routes);
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 배차 시간표 조회
  const SelectLogic1 = async (_param1) => {
    setLoading(true);
    let _carList = [];

    try {
      await Commons.Axios("get", Global.base.useUrl + Global.urls.ChangeCar.ChangeCar, {
        routeId: _param1,
      }).then((result) => {
        let data = result.data;
        // console.log("배차 시간표 조회: ", data);

        if (data.type == "Error") {
          throw new Error(data.message);
        } else if (data === "데이터가 없습니다.") {
          throw new Error(data);
        } else if (data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            _carList.push(data[i]);
          }
          setCarList(_carList);
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 운행 중 배차 시간표 조회
  const SelectLogic2 = async () => {
    setLoading(true);
    let _carList = [];

    try {
      if (!selectBusValue) {
        throw new Error("버스를 선택해주세요.");
      }

      await Commons.Axios("get", Global.base.useUrl + Global.urls.AccidentCar.GetPlan, {
        routeId: selectBusValue,
      }).then(async (result) => {
        let data = result.data;
        // console.log("운행 중 배차 시간표 조회: ", data);

        if (data.type == "Error") {
          throw new Error(data.message);
        } else if (data === "데이터가 없습니다.") {
          throw new Error(data);
        } else if (data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            _carList.push(data[i]);
          }
          setCarList1(_carList);
          await SelectLogic3();
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 정류장 콤보 조회
  const SelectLogic3 = async () => {
    setLoading(true);
    let _stationList = [];

    try {
      await Commons.Axios("get", Global.base.useUrl + Global.urls.Common.GetCode, {
        code: "STATION",
        key1: selectBusValue,
        key2: "",
        key3: "",
        key4: "",
      }).then((result) => {
        let data = result.data;
        // console.log("정류장 콤보 조회: ", data);

        if (data.type == "Error") {
          throw new Error(data.message);
        } else if (data === "데이터가 없습니다.") {
          throw new Error(data);
        } else if (data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            _stationList.push(data[i]);
          }
          setStationList(_stationList);
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 대차 콤보 리스트 조회
  const SelectLogic4 = async () => {
    setLoading(true);
    let _changeCarList = [];

    try {
      if (!selectBusValue) {
        throw new Error("노선을 선택해주세요.");
      }

      await Commons.Axios("get", Global.base.useUrl + Global.urls.Common.GetCode, {
        code: "VEHICLE",
        key1: selectBusValue,
        key2: "",
        key3: "",
        key4: "",
      }).then((result) => {
        let data = result.data;
        // console.log("대차 콤보 리스트 조회: ", data);

        if (data.type == "Error") {
          throw new Error(data.message);
        } else if (data === "데이터가 없습니다.") {
          throw new Error(data);
        } else if (data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            _changeCarList.push(data[i]);
          }
          setChangeCarList(_changeCarList);
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 휴무자 콤보 리스트 조회
  const SelectLogic5 = async () => {
    setLoading(true);
    let _holidayPeopleList = [];

    try {
      await Commons.Axios("get", Global.base.useUrl + Global.urls.AccidentCar.GetDriver, { workyn: "N" }).then((result) => {
        let data = result.data;
        // console.log("휴무자 콤보 리스트 조회: ", data);

        if (data.type == "Error") {
          throw new Error(data.message);
        } else if (data === "데이터가 없습니다.") {
          throw new Error(data);
        } else if (data.id) {
          for (let i = 0; i < JSON.parse(data.result).length; i++) {
            _holidayPeopleList.push(JSON.parse(data.result)[i]);
          }
          setHolidayPeopleList(_holidayPeopleList);
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 근무자 콤보 리스트 조회
  const SelectLogic6 = async () => {
    setLoading(true);
    let _workPeopleList = [];

    try {
      await Commons.Axios("get", Global.base.useUrl + Global.urls.AccidentCar.GetDriver, { workyn: "Y" }).then((result) => {
        let data = result.data;
        // console.log("근무자 콤보 리스트 조회: ", data);

        if (data.type == "Error") {
          throw new Error(data.message);
        } else if (data === "데이터가 없습니다.") {
          throw new Error(data);
        } else if (data.result.length > 0) {
          for (let i = 0; i < JSON.parse(data.result).length; i++) {
            _workPeopleList.push(JSON.parse(data.result)[i]);
          }
          setWorkPeopleList(_workPeopleList);
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 사고/고장 저장
  const SaveLogic = async () => {
    setLoading(true);

    try {
      if (!changeCarRadioValue) {
        throw new Error("대차 처리를 선택하세요.");
      } else if (changeCarRadioValue == "Y" && !changeCarValue) {
        throw new Error("변경할 대차를 선택하세요.");
      }
      // else if (
      //   changeCarRadioValue == "Y" &&
      //   !holidayPeopleValue &&
      //   !workPeopleValue
      // ) {
      //   throw new Error("휴무자 또는 근로자를 선택하세요.");
      // }
      else if (changeCarRadioValue == "Y" && !rideRadioValue) {
        throw new Error("적용 회차를 선택하세요.");
      }

      await Commons.Axios("post", Global.base.useUrl + Global.urls.AccidentCar.Create, {
        opratDt: carList1[selectedCardIndex].opratDt,
        routeId: selectBusValue,
        opratExchngYn: carList1[selectedCardIndex].opratExchngYn,
        opratIdx: carList1[selectedCardIndex].opratIdx,
        carId: carList1[selectedCardIndex].vhcleId,
        newCarId: changeCarValue,
        driverId: carList1[selectedCardIndex].driverId,
        newDriverId: holidayPeopleValue ? holidayPeopleValue : workPeopleValue ? workPeopleValue : carList1[selectedCardIndex].driverId,
        // newDriverId: !holidayPeopleValue
        //   ? workPeopleValue
        //   : holidayPeopleValue,
        amPmDiv: rideRadioValue,
        accidentFlag: accidentRadioValue,
        changeCarFlag: changeCarRadioValue,
        stationIdx: selectStationValue,
      }).then((result) => {
        let data = result.data;
        // console.log("사고/고장 저장: ", data);

        if (data.type === "Error") {
          throw new Error(data.message);
        } else if (data === "Not Data") {
          throw new Error("데이터가 없습니다.");
        } else if (data === "Ok") {
          DialogClosed(1);
          SelectLogic();
          SelectLogic1(selectBusValue);
          SelectLogic2();
          SelectLogic4();
          SelectLogic5();
          SelectLogic6();
          Commons.Toast("success", "저장 되었습니다.");
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 사고/고장 승인
  const SaveLogic1 = async (_param) => {
    setLoading(true);

    try {
      await Commons.Axios("post", Global.base.useUrl + Global.urls.AccidentCar.Complete, _param).then((result) => {
        let data = result.data;
        // console.log("사고/고장 승인: ", data);

        if (data.type === "Error") {
          throw new Error(data.message);
        } else if (data === "Not Data") {
          throw new Error("데이터가 없습니다.");
        } else if (data === "Ok") {
          DialogClosed(1);
          SelectLogic();
          SelectLogic4();
          SelectLogic5();
          SelectLogic6();
          setDialogToggle2(false);
          Commons.Toast("success", "승인 되었습니다.");
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  const DialogChecking = async () => {
    try {
      if (!selectedCardIndex && selectedCardIndex !== 0) {
        throw new Error("운행 차량을 선택하세요.");
      } else if (!accidentRadioValue) {
        throw new Error("사고·고장을 선택하세요.");
      } else if (!selectStationValue) {
        throw new Error("정류장을 선택하세요.");
      }

      await SelectLogic4();
      await SelectLogic5();
      await SelectLogic6();
      setDialogToggle1(true);
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    }
  };

  const DialogClosed = (_type) => {
    if (_type == 1) {
      setDialogToggle1(false);
    } else {
      setDialogToggle1(false);
      setDialogToggle(false);
    }

    setSelectedCardIndex("");
    setAccidentRadioValue("");
    setSelectStationValue("");
    setChangeCarRadioValue("Y");
    setChangeCarValue("");
    setHolidayPeopleValue("");
    setWorkPeopleValue("");
    setRideRadioValue("");
    SelectLogic3();
  };

  return (
    <React.Fragment>
      <Card className='mb-2'>
        <Card.Body className='horizontal-card-body'>
          <Dropdown
            className='me-3'
            variant='outline-primary'
            title={selectedBusTitle}
            items={routes}
            value={selectBusValue}
            onChange={(e) => {
              setSelectBusValue(e);
              Commons.Storages("set", "saves", {
                ...Commons.Storages("get", "saves"),
                busNo: routes.filter((f) => f.value == e)[0].text,
                routeId: e,
              });
              SelectLogic1(e);
            }}
          />
          <Button
            className='me-3'
            size='sm'
            title={<FontAwesomeIcon icon={faStar} color={bookmarkStates.routeId === selectBusValue ? "#ffc301" : "#ffffff"} />}
            onClick={() => {
              if (selectBusValue === "") {
                return false;
              }
              if (selectBusValue !== bookmarkStates.routeId) {
                dispatch(BookmarkActions.setBusNo(routes.filter((f) => f.value == selectBusValue)[0].text));
                dispatch(BookmarkActions.setRouteId(selectBusValue));
                dispatch(BookmarkActions.setBookmarks(true));
              } else if (bookmarkStates.bookmarks || !selectBusValue) {
                dispatch(BookmarkActions.setBusNo("0"));
                dispatch(BookmarkActions.setRouteId("0"));
                dispatch(BookmarkActions.setBookmarks(false));
              } else {
                dispatch(BookmarkActions.setBusNo(routes.filter((f) => f.value == selectBusValue)[0].text));
                dispatch(BookmarkActions.setRouteId(selectBusValue));
                dispatch(BookmarkActions.setBookmarks(true));
              }
            }}
          />
          <Button size='sm' title={<FontAwesomeIcon icon={faRotateRight} onClick={() => SelectLogic1(selectBusValue)} />} />
        </Card.Body>
      </Card>
      <Card>
        <Card.Body className='custom-table-grid-header'>
          <Stack direction='horizontal'>
            <div className='p-2 custom-table-grid-header-text custom-table-text-width-48'>회차</div>
            <div className='p-2 custom-table-grid-header-text custom-table-text-width-80'>출발시간</div>
            <div className='p-2 custom-table-grid-header-text custom-table-text-width-80'>차량번호</div>
            <div className='p-2 custom-table-grid-header-text custom-table-text-width-64'>승무원</div>
            <div className='p-2 custom-table-grid-header-text custom-table-text-width-48'>비고</div>
          </Stack>
        </Card.Body>
      </Card>
      <div className='custom-table-grid-datas mb-3'>
        {carList.map((item, index) => {
          const CheckNumberCar = () => {
            if (index == 0) {
              return "custom-table-grid-datas-first";
            } else if (index == 1 || index == 2) {
              return "custom-table-grid-datas-next";
            } else {
              return "";
            }
          };

          return (
            <Card key={index} className={`${CheckNumberCar()}`}>
              <Card.Body className='custom-table-grid-body'>
                <Stack direction='horizontal'>
                  <div className='p-2 custom-table-grid-body-text custom-table-text-width-48'>{item.opratIdx}</div>
                  <div className='p-2 custom-table-grid-body-text custom-table-text-width-80'>{item.caralcDtm}</div>
                  <div className='p-2 custom-table-grid-body-text custom-table-text-width-80'>{item.vhcleNo}</div>
                  <div className='p-2 custom-table-grid-body-text custom-table-text-width-64'>{item.name}</div>
                  <div
                    className='p-2 custom-table-grid-body-text custom-table-text-width-48'
                    style={{
                      fontSize: item.remark.length > 2 ? "12px" : "1rem",
                    }}
                  >
                    {item.remark}
                  </div>
                </Stack>
              </Card.Body>
            </Card>
          );
        })}
      </div>
      <div>
        <Button
          fullWidth
          title='사고·고장처리'
          onClick={() => {
            if (!selectBusValue) {
              Commons.Toast("error", "버스를 선택해주세요.");
              return false;
            } else {
              SelectLogic2();
              setDialogToggle(true);
            }
          }}
        />
      </div>
      <Dialog header={false} fullscreen show={dialogToggle} onHide={DialogClosed} onClose={() => setSelectedCardIndex("")} sumitButtonName='확인' onSumit={DialogChecking}>
        <Card>
          <Card.Body className='custom-table-grid-header'>
            <Stack direction='horizontal'>
              <div className='p-2 custom-table-grid-header-text custom-table-text-width-48'>회차</div>
              <div className='p-2 custom-table-grid-header-text custom-table-text-width-80'>출발시간</div>
              <div className='p-2 custom-table-grid-header-text custom-table-text-width-80'>차량번호</div>
              <div className='p-2 custom-table-grid-header-text custom-table-text-width-64'>승무원</div>
              <div className='p-2 custom-table-grid-header-text custom-table-text-width-48'>비고</div>
            </Stack>
          </Card.Body>
        </Card>
        <div className='custom-table-grid-datas mb-3' style={{ height: "62vh" }}>
          {carList1.map((item, index) => {
            const isSelected = index === selectedCardIndex;
            const selectedCardColor = isSelected ? "custom-table-grid-selected" : "";

            return (
              <Card key={index} className={`${selectedCardColor}`} onClick={() => setSelectedCardIndex(index)}>
                <Card.Body className='custom-table-grid-body'>
                  <Stack direction='horizontal'>
                    <div className='p-2 custom-table-grid-body-text custom-table-text-width-48'>{item.opratIdx}</div>
                    <div className='p-2 custom-table-grid-body-text custom-table-text-width-64'>{item.caralcDtm}</div>
                    <div className='p-2 custom-table-grid-body-text custom-table-text-width-80'>{item.vhcleNo}</div>
                    <div className='p-2 custom-table-grid-body-text custom-table-text-width-64' style={{ fontSize: item.name.length > 3 ? "12px" : "" }}>
                      {item.name}
                    </div>
                    <div className='p-2 custom-table-grid-body-text custom-table-text-width-64'>
                      {item.remark == "사고" ? (
                        <Button
                          size='sm'
                          title='사고'
                          onClick={() => {
                            setDialogToggle2(true);
                            setSelectedItem(item);
                          }}
                        />
                      ) : item.remark == "고장" ? (
                        <Button
                          size='sm'
                          title='고장'
                          onClick={() => {
                            setDialogToggle2(true);
                            setSelectedItem(item);
                          }}
                        />
                      ) : item.remark == "완료" ? (
                        "완료"
                      ) : item.remark == "1" ? (
                        ""
                      ) : (
                        item.remark
                      )}
                    </div>
                  </Stack>
                </Card.Body>
              </Card>
            );
          })}
        </div>
        <Stack>
          <div className='custom-dialog-inputs-container'>
            <span style={{ minWidth: "30%", fontWeight: "bold" }}>사고·고장</span>
            <Radio
              items={[
                { value: "A", text: "사고" },
                { value: "B", text: "고장" },
              ]}
              value={accidentRadioValue}
              onChange={(e) => setAccidentRadioValue(e)}
            />
          </div>
          <div className='custom-dialog-inputs-container'>
            <span style={{ minWidth: "30%", fontWeight: "bold" }}>정류장</span>
            <Dropdown variant='outline-primary' title={"정류장을 선택하세요."} items={stationList} value={selectStationValue} onChange={(e) => setSelectStationValue(e)} />
          </div>
        </Stack>
      </Dialog>
      <Dialog
        fullscreen
        title={
          routes.length > 0 && routes.some((f) => f.value == selectBusValue) && carList1.length > 0 && Number(selectedCardIndex)
            ? `${routes.find((f) => f.value == selectBusValue).text}번 ${carList1[selectedCardIndex].opratIdx}회차`
            : ""
        }
        show={dialogToggle1}
        onHide={() => DialogClosed(1)}
        sumitButtonName='확인'
        onSumit={SaveLogic}
      >
        <Stack>
          <div className='custom-dialog-inputs-container'>
            <div className='vertical-divider' />
            <span style={{ marginLeft: "4px", color: "#0d6efd" }}>대차 처리</span>
          </div>
          <Radio
            items={[
              { value: "Y", text: "예" },
              { value: "N", text: "아니오" },
            ]}
            value={changeCarRadioValue}
            onChange={(e) => setChangeCarRadioValue(e)}
          />
          <div className='custom-dialog-inputs-container'>
            <div className='vertical-divider' />
            <span style={{ marginLeft: "4px", color: "#0d6efd" }}>배차 차량 변경</span>
          </div>
          <div className='custom-dialog-inputs-container'>
            <span style={{ minWidth: "30%" }}>현재차량</span>
            <span>{carList1.length > 0 && Number(selectedCardIndex) ? carList1[selectedCardIndex].vhcleNo : ""}</span>
          </div>
          <div className='custom-dialog-inputs-container'>
            <span style={{ minWidth: "30%" }}>대차</span>
            <Dropdown
              variant='outline-primary'
              title={"대차를 선택하세요."}
              disabled={changeCarRadioValue == "N" ? true : false}
              items={changeCarList}
              value={changeCarValue}
              onChange={(e) => setChangeCarValue(e)}
            />
          </div>
          <div className='custom-dialog-inputs-container'>
            <div className='vertical-divider' />
            <span style={{ marginLeft: "4px", color: "#0d6efd" }}>승무원 변경</span>
          </div>
          <div className='custom-dialog-inputs-container'>
            <span style={{ minWidth: "30%" }}>현재</span>
            <span>{carList1.length > 0 && Number(selectedCardIndex) ? carList1[selectedCardIndex].name : ""}</span>
          </div>
          <div className='custom-dialog-inputs-container'>
            <span style={{ minWidth: "30%" }}>휴무자</span>
            <Dropdown
              variant='outline-primary'
              title={"변경 승무원을 선택하세요."}
              disabled={changeCarRadioValue == "N" ? true : false}
              items={holidayPeopleList}
              value={holidayPeopleValue}
              onChange={(e) => {
                setHolidayPeopleValue(e);
                if (workPeopleValue) {
                  SelectLogic6();
                }
                setWorkPeopleValue("");
              }}
            />
          </div>
          <div className='custom-dialog-inputs-container'>
            <span style={{ minWidth: "30%" }}>근무자</span>
            <Dropdown
              variant='outline-primary'
              title={"변경 승무원을 선택하세요."}
              disabled={changeCarRadioValue == "N" ? true : false}
              items={workPeopleList}
              value={workPeopleValue}
              onChange={(e) => {
                setWorkPeopleValue(e);
                if (holidayPeopleValue) {
                  SelectLogic5();
                }
                setHolidayPeopleValue("");
              }}
            />
          </div>
          <div className='custom-dialog-inputs-container'>
            <div className='vertical-divider' />
            <span style={{ marginLeft: "4px", color: "#0d6efd" }}>적용 회차</span>
          </div>
          <Radio
            items={[
              {
                value: "2",
                text: "금회",
                disabled: changeCarRadioValue == "N" ? true : false,
              },
              {
                value: "0",
                text: "오전",
                disabled: changeCarRadioValue == "N" ? true : false,
              },
              {
                value: "1",
                text: "오후",
                disabled: changeCarRadioValue == "N" ? true : false,
              },
              {
                value: "3",
                text: "금일",
                disabled: changeCarRadioValue == "N" ? true : false,
              },
            ]}
            value={rideRadioValue}
            onChange={(e) => setRideRadioValue(e)}
          />
        </Stack>
      </Dialog>
      <Dialog title='승인 확인' show={dialogToggle2} onHide={() => setDialogToggle2(false)} sumitButtonName='승인' onSumit={() => SaveLogic1(selectedItem)}>
        <span>승인 하시겠습니까?</span>
      </Dialog>
      <Loading show={loading} />
    </React.Fragment>
  );
}

export default AccidentCar;
